import _defineProperty from "@babel/runtime/helpers/defineProperty";
/*
 *                     NOTICE
 *            COPYRIGHT 2023 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

export class ProductSpecificLocaleStrings {
  constructor(advancedAboutDialogTitle, helpMenuAboutLabel) {
    // the equivalent of abreact's "about.dialog.title"
    _defineProperty(this, "_advancedAboutDialogTitle", void 0);
    // the equivalent of abreact's "help_menu.item.about.label"
    _defineProperty(this, "_helpMenuAboutLabel", void 0);
    this._advancedAboutDialogTitle = advancedAboutDialogTitle;
    this._helpMenuAboutLabel = helpMenuAboutLabel;
  }
  get advancedAboutDialogTitle() {
    return this._advancedAboutDialogTitle;
  }
  get helpMenuAboutLabel() {
    return this._helpMenuAboutLabel;
  }
}
//# sourceMappingURL=ProductSpecificLocaleStrings.js.map
